module.exports = __webpack_public_path__ + "static/best-match-c3eb88c1b4afa9f9a6859ce05a561f69.png";